"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgComparisonSlider = void 0;
const react_1 = __importDefault(require("react"));
if (typeof document !== 'undefined') {
    Promise.resolve().then(() => __importStar(require('img-comparison-slider')));
}
const ImgComparisonSlider = ({ children, onSlide, ...props }) => {
    const ref = react_1.default.createRef();
    react_1.default.useEffect(() => {
        if (props.value !== undefined) {
            ref.current.value = parseFloat(props.value.toString());
        }
    }, [props.value, ref]);
    react_1.default.useEffect(() => {
        if (onSlide) {
            // @ts-ignore
            ref.current.addEventListener('slide', onSlide);
        }
    }, []);
    return react_1.default.createElement('img-comparison-slider', Object.assign({
        class: props.className ? `${props.className} rendered` : 'rendered',
        // Align tabIndex between the web and React components
        // this code could be removed when
        // https://github.com/WICG/webcomponents/issues/762 is resolved.
        tabIndex: 0,
        ref,
    }, props), children);
};
exports.ImgComparisonSlider = ImgComparisonSlider;
//# sourceMappingURL=index.js.map